export interface MenuOption extends Record<string, unknown> {
  selected?: boolean;
  disabled?: boolean;
}

export enum MenuSize {
  S = 's',
  M = 'm',
  L = 'l',
}
